// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preStartup-tab-no-padding .q-tab-panel {\n  padding: 3px !important;\n}\n.preStartup-tab-no-padding .q-tab-panel .q-table__container {\n  margin: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
